"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AvatarGroup.default;
  }
});

var _AvatarGroup = _interopRequireDefault(require("./AvatarGroup"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/AvatarGroup/index.js
// module id = 892
// module chunks = 0